/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_New_Document_AnalysisInputs */

const en_page_title_new_document_analysis = /** @type {(inputs: Page_Title_New_Document_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New document analysis`)
};

const nl_page_title_new_document_analysis = /** @type {(inputs: Page_Title_New_Document_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuwe documentanalyse`)
};

/**
* | output |
* | --- |
* | "New document analysis" |
*
* @param {Page_Title_New_Document_AnalysisInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_new_document_analysis = /** @type {((inputs?: Page_Title_New_Document_AnalysisInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_New_Document_AnalysisInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_new_document_analysis(inputs)
	return en_page_title_new_document_analysis(inputs)
});